import { render, staticRenderFns } from "./provider-table.vue?vue&type=template&id=0d2524fb"
import script from "./provider-table.vue?vue&type=script&lang=js"
export * from "./provider-table.vue?vue&type=script&lang=js"
import style0 from "./provider-table.vue?vue&type=style&index=0&id=0d2524fb&prod&lang=scss&module=true"
import style1 from "./provider-table.vue?vue&type=style&index=1&id=0d2524fb&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports